export function formatNumber(
  number: number | string,
  options: Intl.NumberFormatOptions & {
    roundingMode?:
      | "ceil"
      | "floor"
      | "expand"
      | "trunc"
      | "halfCeil"
      | "halfFloor"
      | "halfExpand"
      | "halfTrunc"
      | "halfEven";
  } = {}
) {
  return new Intl.NumberFormat("en-US", options).format(Number(number));
}

export function formatCurrency(
  number: number | string,
  options: Intl.NumberFormatOptions & {
    verboseNegligibleValue?: boolean;
    approximateValue?: boolean;
  } = {}
) {
  const { verboseNegligibleValue, approximateValue, ...formatOptions } =
    options;

  const formatted = formatNumber(number, {
    ...formatOptions,
    style: "currency",
    currency: "USD",
  });

  if (approximateValue) {
    if (formatted === "$0.00" && Number(number) > 0) {
      return "~$0.01";
    }

    return `~${formatted}`;
    // biome-ignore lint/style/noUselessElse: Otherwise verboseNegligibleValue is ignored
  } else if (
    verboseNegligibleValue &&
    formatted === "$0.00" &&
    Number(number) > 0
  ) {
    return "Less than $0.01";
  }

  return formatted;
}
